export default __webpack_public_path__ + "static/media/typeform.a7da8e43.svg";